import apiURL from'./apiURL';
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];




// types of action
const Types = {
  CREATE_ACCOUNT_CREATING: "CREATE_ACCOUNT_CREATING",
  CREATE_ACCOUNT_USER_CREATED: "CREATE_ACCOUNT_USER_CREATED",
  CREATE_ACCOUNT_USER_CREATION_FAILED: "CREATE_ACCOUNT_USER_CREATION_FAILED",
  CREATE_ACCOUNT_USER_UPDATED: "CREATE_ACCOUNT_USER_UPDATED",
  CREATE_ACCOUNT_AC_LEAD: "CREATE_ACCOUNT_AC_LEAD",
  CREATE_ACCOUNT_DEMO_CREATED: "CREATE_ACCOUNT_DEMO_CREATED",
  CREATE_ACCOUNT_SAVING_LEAD: "CREATE_ACCOUNT_SAVING_LEAD",
  CREATE_ACCOUNT_SAVED_LEAD: "CREATE_ACCOUNT_SAVED_LEAD",
  CREATE_ACCOUNT_CONTACT_LISTS: "CREATE_ACCOUNT_CONTACT_LISTS",
  CREATE_ACCOUNT_ADD_TAG: "CREATE_ACCOUNT_ADD_TAG",
  CREATE_ACCOUNT_WEBINAR_SUBSCRIBE: "CREATE_ACCOUNT_WEBINAR_SUBSCRIBE",
  CREATE_ACCOUNT_WEBINAR_SUBSCRIBING: "CREATE_ACCOUNT_WEBINAR_SUBSCRIBING",
  CREATE_ACCOUNT_DATA: "CREATE_ACCOUNT_DATA",
};

const setNewAccountData = (data) => ({
  type: Types.CREATE_ACCOUNT_DATA,
  data,
});


const userAccountCreated = (response) => ({
  type: Types.CREATE_ACCOUNT_USER_CREATED,
  payload: response,
});

const userAccountCreationFailed = (error) => ({
  type: Types.CREATE_ACCOUNT_USER_CREATION_FAILED,
  error,
});

const creatingAccount = (noOfEmployees,organisation) => ({
  type: Types.CREATE_ACCOUNT_CREATING,
  organisation,
  noOfEmployees
});

const acDealCreated = () => ({
  type: Types.CREATE_ACCOUNT_AC_LEAD,
});

const demoAccountCreated = () => ({
  type: Types.CREATE_ACCOUNT_DEMO_CREATED,
});


/* const createAccount = (data) => {

  return (dispatch, getState) => {

    const {organisation, vatNo, door, street, city, postcode} = data

    const state = getState()
    dispatch(creatingAccount(organisation))

    if (!(email == "" && state.my && state.my.profile && state.my.profile.email)){

      fetch(apiURL + '/authentication/create' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({email,password}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //'Organisation': getState().currentOrganisation,
          },
      })
      .then(response => response.json())
      .then(data => {

        if (data.error){
          dispatch(userAccountCreationFailed(data.error))
        } else {

          console.log('entity data',data)
          dispatch(userAccountCreated(data))

          // once account created let's creat the demo account
          fetch(apiURL + '/demo/create' , {
              credentials: 'include',
              method: 'POST',
              body: JSON.stringify({}),
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                //'Organisation': getState().currentOrganisation,
              },
          })
          .then(response => response.json())
          .then(data => {
            console.log('entity data',data)
            dispatch(demoAccountCreated(data))

            // once account created let's creat the demo account

          })
        }

      })
    } else if (state.my.profile.isHR == 0){
      fetch(apiURL + '/demo/create' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //'Organisation': getState().currentOrganisation,
          },
      })
      .then(response => response.json())
      .then(data => {
        console.log('entity data',data)
        dispatch(demoAccountCreated(data))

        // we can redirect as account already existed
        window.location.href = window.location.hostname.includes('stage') || window.location.hostname.includes('local') ? "https://app.stage.buddy.hr/dashboard/" : "https://buddy.hr/dashboard/"

      })
    }

    const dealEmail = email && email != '' ? email : state.my.profile.email
    

    fetch(apiURL + '/authentication/createDeal' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({email: dealEmail, organisation, noOfEmployees}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          //'Organisation': getState().currentOrganisation,
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('acDeal',data)
      dispatch(acDealCreated(true))
    })
  }
} */


const saveUserPersonalDetails = (response,attempt) => ({
  type: Types.CREATE_ACCOUNT_USER_UPDATED,
  payload: response,
  attempt
});

const updateUserDetails = (data) => {
  return (dispatch, getState) => {

    const {email,name,surname,phone} = data

    const state = getState()
    // dispatch(loggingIn(true))

    if (!((name && name == '') && state.my && state.my.profile && state.my.profile.name)){
      console.log('name',name,state.my.profile)
      fetch(apiURL + '/authentication/update' , {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({email,name,surname,phone}),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            /*'Organisation': getState().currentOrganisation,*/
          },
      })
      .then(response => response.json())
      .then(data => {
        console.log('entity data',data)
        dispatch(saveUserPersonalDetails(data,true))
      })
    } else {

    }
  }
}



const savingLead = (data) => ({
  type: Types.CREATE_ACCOUNT_SAVING_LEAD,
  data
});

const savedLead = (response,label) => ({
  type: Types.CREATE_ACCOUNT_SAVED_LEAD,
  payload: response,
  label
});

const saveLead = (data,label) => {
  return (dispatch, getState) => {

    // just forward all no need to extract
    // const {email,name,surname,phone,organisation,noOfEmployees,list} = data

    const state = getState()
    dispatch(savingLead(data))

    fetch(apiURL + '/authentication/saveLead' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(savedLead(data,label))
      dispatch(contactInList({email: data.email}))
    })
  }
}

const inList = (response) => ({
  type: Types.CREATE_ACCOUNT_CONTACT_LISTS,
  payload: response,
});


const contactInList = (data) => {
  return (dispatch, getState) => {

    // just forward all no need to extract
    // const {email,name,surname,phone,organisation,noOfEmployees,list} = data

    const state = getState()

    const list = data.list

    fetch(apiURL + '/authentication/contactLists' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(inList(data))
    })
  }
}

const subscribingToWebinars = () => ({
  type: Types.CREATE_ACCOUNT_WEBINAR_SUBSCRIBING
});

const subscribedToWebinars = (response) => ({
  type: Types.CREATE_ACCOUNT_WEBINAR_SUBSCRIBE,
  payload: response,
});

const subscribeToWebinar = (data) => {
  return (dispatch, getState) => {

    dispatch(subscribingToWebinars())

    const state = getState()

    fetch(apiURL + '/authentication/subscribeToWebinar' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(subscribedToWebinars(data))
    })
  }
}

const tagAdded = (response) => ({
  type: Types.CREATE_ACCOUNT_ADD_TAG,
  payload: response,
});

const addTag = (data) => {
  return (dispatch, getState) => {

    dispatch(subscribingToWebinars())

    const state = getState()

    fetch(apiURL + '/authentication/addTag' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(tagAdded(data))
    })
  }
}


const Actions = {
  setNewAccountData,
  //createAccount,
  updateUserDetails,
  saveLead,
  contactInList,
  subscribeToWebinar,
  addTag,
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions